<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Library"
                   :links="[{title:'Home', url:'/'},{title:'Library',url:'/about'},{title:'Digital Library'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="2"></sidebar>
        </section>
        <section class="content">
          <div class="flex heading-black1 justify-center uppercase font-serif mb-8">digital library or e-resource</div>
          <Accordion :activeIndex="0">
            <AccordionTab header="E-resources available in Library">
              <table class="achievements">
                <thead>
                <tr>
                  <th scope="col">E-Resources</th>
                  <th scope="col">URL Link to Resources</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>DELNET (Developing Library Network) annual membership</td>
                  <td class="hover:text-pink-600">
                    <a href="http://164.100.247.26/" target="_blank">http://164.100.247.26/</a>
                  </td>
                </tr>
                <tr>
                  <td>NDL( National Digital Library)</td>
                  <td class="hover:text-pink-600">
                    <a href="https://ndl.iitkgp.ac.in" target="_blank">https://ndl.iitkgp.ac.in</a>
                  </td>
                </tr>
                <tr>
                  <td>Syllabus</td>
                  <td class="hover:text-pink-600">
                    <a href="http://www.unipune.ac.in/university_files/syllabi.htm" target="_blank">http://www.unipune.ac.in/university_files/syllabi.htm</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </AccordionTab>
            <AccordionTab header="Open access E-Resources for MOOC’s, Books, Journals and Theses">
              <DataTable :value="Resources" :rowHover="true">
                <Column field="name" header="E-Resources">
                  <template #body="slotProps">
                    <p v-html="slotProps.data.name"></p>
                  </template>
                </Column>
                <Column field="link" class="hover:text-pink-600" header="URL Link to Resources">
                  <template #body="slotProps">
                    <a :href="slotProps.data.link" v-text="slotProps.data.link" target="_blank"/>
                  </template>
                </Column>
              </DataTable>
            </AccordionTab>
            <AccordionTab header="Newspapers">
              <DataTable :value="Newspapers" :rowHover="true">
                <Column field="no" header="Sr.No."></Column>
                <Column field="name" class="hover:text-pink-600" header="Newspapers"></Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </section>
      </div>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/library/Sidebar";
import Programmes from "@/views/about/Programmes";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';


export default {
  name: "DigitalLibrary",
  components: {
    Programmes,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    Accordion,
    AccordionTab,
    DataTable, Column,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      Resources: [
        {
          name: '<strong>SWAYAM</strong>: Open Online Education Courses. This is a programme initiated by Government of India. The objective of this effort is to take the best teaching learning resources to all. This platform provides all the courses, taught in classrooms from 9th class till post-graduation and it is accessed by anyone, anywhere at any time.',
          link: 'http://swayam.gov.in'
        },
        {
          name: '<strong>Reliable Academy</strong>: Link to Competitive Exam Preparation',
          link: 'https://reliableacademy.com'
        },
        {
          name: '<strong>Unique Acadamy</strong> : Link to Competitive',
          link: 'https://uniqueacadamy.com'
        },
        {
          name: '<strong>NPTEL</strong>: Provides E-learning through online web and video courses in Engineering, Science and Humanities streams.',
          link: 'https://nptel.ac.in/'
        },
        {
          name: '<strong>CEC Digital Media Library</strong>: It is central repository of all educational video programmes produced by EMRC centres.',
          link: 'http://www.cec.nic.in/cec'
        },
        {
          name: '<strong>e-PG Pathashala</strong>: National Mission on Education through ICT and UGC initiative: A curriculum-based, interactive content in different subjects across all disciplines is being developed under this initiative.',
          link: 'https://epgp.inflibnet.ac.in'
        },
        {
          name: '<strong>Shodhganga</strong> : A Reservoir of Indian Theses It is an Open Access Repository of full-text theses submitted to universities in India. Membership is not required to browse, view, search and download theses available in Shodhganga.',
          link: 'https://shodhganga.inflibnet.ac.in/'
        },
        {
          name: '<strong>DOAJ</strong>: Free, full text, quality controlled scientific and scholarly journals, covering all subjects and many languages.',
          link: 'https://doaj.org'
        }, {
          name: '<strong>DOAB</strong>: DOAB is a community-driven discovery service that indexes and provides access to scholarly, peer-reviewed open access books and helps users to find trusted open access book publishers. All DOAB services are free of charge and all data is freely available.',
          link: 'https://www.doabooks.org'
        },
        {
          name: '<strong>OALIB</strong>: Open Access Library OALib is currently hosting links and metadata to more than 5,457,927 open access articles covering a wide range of academic disciplines. All full text articles from your search results are free to download.',
          link: 'https://www.oalib.com'
        },
        {
          name: '<strong>Google Scholar</strong>: A search engine which provides a search of scholarly literature.',
          link: 'https://scholar.google.com'
        },
        {
          name: '<strong>Internet Archive</strong>: It is a non-profit library of millions of free books, movies, software, music, websites, and more.',
          link: 'https://archive.org'
        },
        {
          name: '<strong>Project Gutenberg</strong>: Offers over 60,000 free ebooks: choose among free epub books, free kindle books, download them or read them online.',
          link: 'https://www.gutenberg.org'
        },
        {
          name: '<strong>Mathway</strong>: Provides students with the tools they need to understand and solve their math problems.  With millions of users and billions of problems solved, Mathway is the #1 problem solving resource available for students, parents, and teachers.',
          link: 'https://www.mathway.com/BasicMath'
        },
        {
          name: '<strong>KnowIndia</strong>: Site to explore full information on India.',
          link: 'https://knowindia.gov.in'
        },
        {
          name: '<strong>Nobel Prizes</strong>: Archives for Nobel Prize winners.',
          link: 'http://nobelprizes.com'
        },
      ],
      Newspapers: [
        {
          no: 1,
          name: 'Sakal ( Marathi)'
        },
        {
          no: 2,
          name: 'Lokmat ( Marathi)'
        },
        {
          no: 3,
          name: 'Divya Marathi'
        },
        {
          no: 4,
          name: 'Loksatta ( Marathi)'
        },
        {
          no: 5,
          name: 'The Indian Express (English)'
        },
        {
          no: 6,
          name: 'The Times Of India ( English )'
        },
        {
          no: 7,
          name: 'Navbharat (Hindi)'
        },

      ],
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0.6rem;
}

::v-deep(.p-datatable) {
  .p-datatable-header {
    background: #e6e6e6;
    color: #404040;
  }

  .p-datatable-thead > tr > th {
    background: #e6e6e6;
    color: #404040;
  }
}
</style>
